import { useId, type SelectHTMLAttributes } from 'react';
import { Icon } from './Icon.js';
import { cx } from './cx.js';

export type SelectOption = string | { value: string; label: string };

/**
 * Liste déroulante native (clavier, lecteurs d'écran et mobile gratuits).
 * Pour 2 à 5 options courtes et stables, préférer Tabs.
 */
export function Select({ label, hint, options, size = 'md', className, id, ...rest }: {
  label?: string;
  hint?: string;
  options: SelectOption[];
  size?: 'md' | 'sm';
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'>) {
  const autoId = useId();
  const selectId = id ?? autoId;
  return (
    <div className={cx('pl-field', className)}>
      {label && <label className="pl-field-label" htmlFor={selectId}>{label}</label>}
      <div className={cx('pl-select-wrap', size === 'sm' && 'pl-select-sm')}>
        <select {...rest} id={selectId} className="pl-select-input">
          {options.map((o) => {
            const opt = typeof o === 'string' ? { value: o, label: o } : o;
            return <option key={opt.value} value={opt.value}>{opt.label}</option>;
          })}
        </select>
        <Icon name="chevron-down" size={14} className="pl-select-chevron" />
      </div>
      {hint && <div className="pl-field-hint">{hint}</div>}
    </div>
  );
}
